import { useState } from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { NSButton, NSCard, NSLoadingScreen } from 'bricks';
import { useQuery } from '@tanstack/react-query';
import ContactCard from './ContactCard';
import ViewAllModal from './ViewAllModal';
import UpsertContactsModal from './UpsertContactsModal';
import getCRMDealContactsQueryOptions from './hooks/useGetCRMDealContacts';

export interface IDealContactsProps {
    organizationId: string;
    dealId: number;
}

const Contacts = ({ organizationId, dealId }: IDealContactsProps) => {
    const maxToDisplay = 3;
    const [showAll, setShowAll] = useState(false);
    const [showUpsertModal, setShowUpsertModal] = useState(false);

    const {
        data: contacts,
        isSuccess,
    } = useQuery(getCRMDealContactsQueryOptions(organizationId, dealId));

    return isSuccess ? (
        <div className="border-bottom p-2">
            <div className="d-flex justify-content-between align-items-center">
                <h5 className="text-white font-weight-bold my-1">
                    {`Contacts (${contacts.length})`}
                </h5>
                <NSButton
                    icon="plus"
                    text="Associate contact"
                    className="text-primary p-0 d-block font-weight-normal heap-deal-activity-associate-contact"
                    callback={() => setShowUpsertModal(!showUpsertModal)}
                />
            </div>
            {!contacts.length && (
                <NSCard className="p-3 mt-2 mb-1 bg-primary-lighten shadow-none">
                    <p className="text-white mb-1">
                        Automatically populate your Activity Log by associating contacts
                    </p>
                    <div>
                        <NSButton
                            text="Associate contact"
                            outline={false}
                            color="primary"
                            className="heap-deal-activity-associate-contact"
                            callback={() => setShowUpsertModal(!showUpsertModal)}
                        />
                    </div>
                </NSCard>
            )}
            {contacts
                .slice(0, maxToDisplay)
                .map(contact => <ContactCard key={contact.correlationId} {...contact} />)}

            {contacts.length > maxToDisplay && (
                <NSButtonBase
                    callback={() => setShowAll(!showAll)}
                    text="View all associated contacts"
                    icon={faChevronRight}
                    iconPosition="right"
                    className="font-weight-normal text-primary p-0 heap-deal-activity-view-associated-contacts"
                />
            )}

            <ViewAllModal
                isOpen={showAll}
                toggle={() => setShowAll(!showAll)}
                title="View all associated contacts"
            >
                { contacts.map(contact => <ContactCard key={contact.correlationId} {...contact} />) }
            </ViewAllModal>

            {!!showUpsertModal && (
                <UpsertContactsModal
                    isOpen={showUpsertModal}
                    organizationId={organizationId}
                    dealId={dealId}
                    toggle={() => setShowUpsertModal(!showUpsertModal)}
                    existingAssociations={contacts}
                />
            )}

        </div>
    ) : (
        <NSLoadingScreen />
    );
};
export default Contacts;
